import React, { useState } from 'react';
import { CheckCircle2, Loader2, Sparkles } from 'lucide-react';
export function ScheduleForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [formData, setFormData] = useState({
    windows: '',
    city: '',
    floors: '1'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
    }, 1500);
  };
  if (status === 'success') {
    return <div className="bg-white rounded-3xl p-8 shadow-xl border border-sky-100 text-center animate-in fade-in zoom-in duration-300" data-id="element-1">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2">
          <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-3" />
        </div>
        <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-4">
          You're all set!
        </h3>
        <p className="text-slate-600 mb-6" data-id="element-5">
          Thanks for choosing Curti-see. We'll be in touch shortly to confirm
          your appointment in {formData.city}.
        </p>
        <button onClick={() => {
        setStatus('idle');
        setFormData({
          windows: '',
          city: '',
          floors: '1'
        });
      }} className="text-teal-600 font-medium hover:text-teal-700 transition-colors" data-id="element-6">
          Schedule another property
        </button>
      </div>;
  }
  return <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-sky-100 relative overflow-hidden" data-id="element-7">
      {/* Decorative sparkle */}
      <div className="absolute -top-4 -right-4 text-sky-50 opacity-50 pointer-events-none" data-id="element-8">
        <Sparkles className="w-24 h-24" data-id="element-9" />
      </div>

      <div className="relative z-10" data-id="element-10">
        <h3 className="text-xl font-bold text-slate-900 mb-1" data-id="element-11">
          Get a Free Quote
        </h3>
        <p className="text-slate-500 text-sm mb-6" data-id="element-12">
          Tell us about your space and we'll handle the shine.
        </p>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-13">
          <div data-id="element-14">
            <label htmlFor="city" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-15">
              Which city are you in?
            </label>
            <input type="text" id="city" required placeholder="e.g. Seattle" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none transition-all placeholder:text-slate-400 bg-slate-50 focus:bg-white" value={formData.city} onChange={e => setFormData({
            ...formData,
            city: e.target.value
          })} data-id="element-16" />
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-17">
            <div data-id="element-18">
              <label htmlFor="windows" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-19">
                Window count
              </label>
              <input type="number" id="windows" required min="1" placeholder="10" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none transition-all placeholder:text-slate-400 bg-slate-50 focus:bg-white" value={formData.windows} onChange={e => setFormData({
              ...formData,
              windows: e.target.value
            })} data-id="element-20" />
            </div>

            <div data-id="element-21">
              <label htmlFor="floors" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-22">
                Floors
              </label>
              <select id="floors" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none transition-all bg-slate-50 focus:bg-white appearance-none cursor-pointer" value={formData.floors} onChange={e => setFormData({
              ...formData,
              floors: e.target.value
            })} data-id="element-23">
                <option value="1" data-id="element-24">1 Story</option>
                <option value="2" data-id="element-25">2 Stories</option>
                <option value="3" data-id="element-26">3 Stories</option>
                <option value="4+" data-id="element-27">4+ Stories</option>
              </select>
            </div>
          </div>

          <button type="submit" disabled={status === 'submitting'} className="w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg shadow-teal-600/20 transform transition-all active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 mt-2" data-id="element-28">
            {status === 'submitting' ? <>
                <Loader2 className="w-5 h-5 animate-spin" data-id="element-29" />
                Processing...
              </> : 'Schedule First Cleaning'}
          </button>

          <p className="text-xs text-center text-slate-400 mt-4" data-id="element-30">
            No credit card required for quotes.
          </p>
        </form>
      </div>
    </div>;
}